import textures from "../viewer/textures/map-preview";

export const emptyBasemapID = "no-basemap";

export const aerialBasemaps = [
  {
    id: emptyBasemapID,
    text: "user-settings.no_base_map",
    src: textures["no-basemap"]
  },
  {
    id: "open-street-maps",
    text: "OpenStreetMaps",
    src: textures["open-street-maps"]
  },
  {
    id: "arcgis-world",
    text: "ArcGIS World",
    src: textures["arcgis-world"]
  },
  {
    id: "arcgis-street",
    text: "ArcGIS Street",
    src: textures["arcgis-street"]
  }
];